
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"62","height":"63","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.5 31.5c0-1.427 1.388-2.583 3.1-2.583h24.8c1.712 0 3.1 1.156 3.1 2.583 0 1.427-1.388 2.583-3.1 2.583H18.6c-1.712 0-3.1-1.156-3.1-2.583z","fill":"#313131"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      